import ReactMarkdown from 'react-markdown';
import Button from '../../../atoms/button';

interface ResearchConsentTabProps {
  onClose?: () => void;
}

const markdown = `By clicking yes, I hereby consent to sharing my information and data regarding my participation as an informant in the study on lifelong learning and technology-driven competence and skill shifts as described below.

The study is part of a research project dealing with the aspects of technology-driven competence and skill shifts. The project is headed by researchers at the Royal Institute of Technology (KTH). The study runs until 2024.

### What is the purpose of the data collection and research?
The purpose of this consent form is to inform about and collect consent regarding data collection connected to the project. Data on aspects of competence and skill needs, and the management and practice of shifting competence and skill, will be collected by KTH for research purposes. The data and information collected will not be shared with third parties outside the scope of the project and is regulated under the GDPR regulation. 

### What kind of data is collected?
Answers to different tasks and interactions within the platform are collected. The data will be anonymized when used in research.

### Data management
The data collected will be stored for 10 years due to the necessity of future research validation.

### Who will use the data collected?
The data is used by researchers at KTH in research. Excerpts from raw data, pseudonymised, may be shared with third parties as part of research papers and reports.

### Risks and discomforts
There are no risks or discomforts related to the research.

### Confidentiality
The gathered interview data for research purposes are treated pseudonymously and in accordance with GDPR regulations.

### Contact
For questions regarding the research conducted, please contact PI [wiggberg@kth.se](mailto:wiggberg@kth.se).

By volunteering as an informant in the study and research project, you agree that you have understood the information above, and agree that your information will be collected and used for the aforementioned purposes. 

This consent is voluntary and can be withdrawn at any time. Please contact Mattias Wiggberg, Researcher, at KTH on [wiggberg@kth.se](mailto:wiggberg@kth.se). 
`;

export default function ResearchConsentTab({ onClose }: ResearchConsentTabProps) {
  return (
    <div className="information-tab">
      <div className="[&>p]:mb-4 mb-8">
        <ReactMarkdown>{markdown}</ReactMarkdown>
      </div>
      <div className="flex">
        <Button className="mx-auto" visualType="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}
